import { parseDefiniteQuotationDTO, QuotationDTO } from 'components/ordering/quotation/api/dtos/quotation-dto.js'
import { StatusCodeToError } from 'components/ordering/quotation/api/dtos/error.js'
import { QuotationRequest } from 'components/ordering/quotation/api/quotation-request.js'

const EXPECTED_ERRORS = [404] as const
type ExpectedErrors = StatusCodeToError<typeof EXPECTED_ERRORS[number]>

type GetQuotationPayload = {
  quotationId: number
}

export class GetQuotation extends QuotationRequest<QuotationDTO, ExpectedErrors> {
  path: string
  override expectedErrors = EXPECTED_ERRORS

  constructor({ quotationId }: GetQuotationPayload) {
    super()

    this.path = `quotation/${quotationId}/`
  }

  override parseResponse = parseDefiniteQuotationDTO
}
